<template>

    <section :id="name+'crud'" class="list-view">
        <slot></slot>
    </section>

</template>

<script>
    export default {
        props:['name'],
        data() {
            return {}
        },
        watch: {},
        computed: {},
        methods: {},
        mounted() {}
    }
</script>   

<style lang="scss">
    section.list-view{
        @include grid-collapse();
        @include clearfix();
        @include mobile(){
            margin-top:-1em;
        }
    }
</style>
